import React, {useState} from "react";
import styled from "styled-components";
import Input from "../common/Input";
import Button from "../common/Button";
import SelectBox from "../common/Select";
import axios from "axios";
import {toast} from "react-toastify";
import {useStore} from "../../app/store";
import {ModalBody} from "./Modal";

const AccountModal = ({
                          entryType,
                          modalMutate,
                          handleCloseModal,
                          modalDepth,
                      }) => {
    const {userStore} = useStore();
    let [inputState1, setInputState1] = useState(userStore.info.userName);
    const inputText1 = (e) => {
        setInputState1(e.target.value);
    }
    let [inputState2, setInputState2] = useState(userStore.info.userId);
    const inputText2 = (e) => {
        setInputState2(e.target.value);
    }
    let [companyValue, setCompanyValue] = useState(userStore.info.affiliation);
    const companyArr = [
        {value: "안다르", label: "안다르"},
        {value: "이너뷰", label: "이너뷰"},
    ];
    let [teamValue, setTeamValue] = useState(userStore.info.team);
    const teamArr = [
        {
            value: "안다르", label: "안다르", options: [
                {value: "마스터", label: "마스터"},
                {value: "기획팀", label: "기획팀"},
                {value: "디자인팀", label: "디자인팀"},
            ]
        },
        {
            value: "이너뷰", label: "이너뷰", options: [
                {value: "기획팀", label: "기획팀"},
                {value: "디자인팀", label: "디자인팀"},
                {value: "개발팀", label: "개발팀"},
            ]
        },
    ];
    let [roleValue, setRoleValue] = useState(userStore.info.permissionGroup);
    const roleArr = [
        {value: "master", label: "마스터"},
        {value: "editor", label: "에디터"},
        {value: "gm", label: "관리자"},
    ];
    return (
        <ModalBody id={"AccountSetModal"}>
            <AccountSettingWrap>
                <div className="input-wrap">
                    <Input
                        onChange={(e) => {
                            inputText2(e)
                        }}
                        placeholder={"andar12"}
                        id={"account_id"}
                        label={"아이디"}
                        value={inputState2}
                        disabled={entryType && entryType === "UPDATE"}
                    />
                </div>

                <div className="input-wrap">
                    <Input
                        onChange={(e) => {
                            inputText1(e)
                        }}
                        placeholder={"홍길동"}
                        id={"name"}
                        label={"이름"}
                        value={inputState1}
                    />
                </div>

                <div className="input-wrap">
                    <label>소속</label>
                    <SelectBox
                        option={companyArr}
                        size={"fill"}
                        classNamePrefix="선택"
                        placeholder={"선택"}
                        isSearchable={false}
                        onChange={(e) => {
                            setCompanyValue(e.label);
                            setTeamValue("");
                        }}
                        value={companyArr.filter((option) => option.label === companyValue)}
                    />
                </div>

                <div className="input-wrap">
                    <label>팀</label>
                    <SelectBox
                        option={teamArr.filter((x) => x.label === companyValue)}
                        size={"fill"}
                        classNamePrefix={""}
                        placeholder={"선택"}
                        isSearchable={false}
                        onChange={(e) => {
                            setTeamValue(e)
                        }}
                        value={teamValue}
                    />
                </div>

                <div className="input-wrap">
                    <label>권한</label>
                    <SelectBox
                        option={roleArr}
                        size={"fill"}
                        classNamePrefix={""}
                        placeholder={"선택"}
                        isSearchable={false}
                        onChange={(e) => setRoleValue(e.label)}
                        value={roleArr.filter((option) => option.label === roleValue)}
                    />
                </div>

                <div className="btn-wrap">
                    <Button
                        type={"fill"}
                        size={"l"}
                        text={"저장"}
                        onClickFunc={async () => {
                            try {
                                if (entryType === "UPDATE") {
                                    let moreData = {
                                        userName: inputState1,
                                        userId: inputState2,
                                        affiliation: companyValue,
                                        team: teamValue.label,
                                        permissionGroupId: userStore.permission.find(p => p.name === roleValue)._id,
                                        _id: userStore.info._id,
                                    };
                                    await axios.patch("/users/updateInfo", moreData);
                                    await modalMutate();
                                    handleCloseModal(modalDepth);
                                    toast(`저장 되었습니다.`);
                                } else if (entryType === "NEW") {
                                    let moreData = {
                                        userId: inputState2,
                                        userName: inputState1,
                                        affiliation: companyValue,
                                        team: teamValue.label,
                                        permissionGroupId: "",
                                    };

                                    const res = await axios.get("/users/permissionGroup?detail=true")
                                    let permission = res.data.data['permissionGroups'];
                                    permission.forEach((e, i) => {
                                        let name = e.name;
                                        if (roleValue === name) {
                                            moreData.permissionGroupId = e._id;
                                        }
                                    });
                                    await axios.post("/users/new", moreData);
                                    await modalMutate();
                                    handleCloseModal(modalDepth);
                                    toast(`신규 생성 되었습니다.`);
                                }
                            } catch (e) {
                                if (e.code !== "ALREADY_EXIST_USER_ID") {
                                    console.log(`오류가 발생였습니다.\n${e.message}`);
                                }
                            }

                        }}
                    />
                </div>
            </AccountSettingWrap>
        </ModalBody>
    );
};


const AccountSettingWrap = styled.div`
    background-color: #fff;
    padding: 32px;

    div.btn-wrap {
        margin-top: 32px;

        button {
            background: var(--Gray-1000_-262626, #262626);
            color: #fff;
            border-color: var(--Gray-1000_-262626, #262626);
            width: 100%;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
            letter-spacing: -0.14px;
            font-size: 14px;

            &:hover {
                background-color: #000;
            }
        }
    }

    div.input-wrap {
        margin-bottom: 24px;

        label {
            display: block;
            width: 100%;
            margin-bottom: 8px;
            color: var(--Gray-1000_-262626, #262626);
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            letter-spacing: -0.13px;
        }

        input {
            height: 32px;
            padding: 0 12px;
            font-size: 12px;

            &:disabled {
                color: #C8C8C8;
                border-color: #eee;
                background: #FAFAFA;
            }
        }
    }
`;
export default AccountModal;
